import { FC, useMemo } from "react"
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar, Legend, Tooltip } from "recharts"
import { CustomXAxisTickOffsetX, customLegend, customTooltip, getYAxisWidth } from "../utility";
import { TopSpecialtiesByGapData } from "../interfaces";

interface TopSpecialtiesByGapTableProps {
  tableData: TopSpecialtiesByGapData[];
  barHoverBackground?: string;
  fillableGapsPrimary: string;
  unfillableGaps: string;
  isExport: boolean;
}
const TopSpecialtiesTable: FC<TopSpecialtiesByGapTableProps> = (props: TopSpecialtiesByGapTableProps) => {

  const yAxisWidth = useMemo(() => {
    const yAxisValues = props.tableData?.map((d) => d.fillableGapCount + d.unfillableGapCount);
    return getYAxisWidth(yAxisValues);
  }, [props.tableData]);

  return (
    <div style={{ height: "450px", width: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          margin={{ left: 20 }}
          data={props.tableData}
        >
          <CartesianGrid strokeDasharray="0 3" />
          <XAxis
            dataKey="specialtyGroupDisplayName"
            height={55}
            tickLine={false}
            angle={-15}
            tickSize={12}
            interval={0}
            tick={<CustomXAxisTickOffsetX />}
            padding={{ left: 1, right: 1 }}
          />
          <YAxis
            axisLine={true}
            tickLine={false}
            width={yAxisWidth}
            allowDecimals={false}
            tickFormatter={(tick: number) => tick.toLocaleString()}
          />
          <Bar
            dataKey="fillableGapCount"
            fill={props.fillableGapsPrimary}
            barSize={40}
            name="Composite Fillable Gaps"
            stackId="stack"
          />
          <Bar
            dataKey="unfillableGapCount"
            fill={props.unfillableGaps}
            barSize={40}
            name="Unfillable Gaps"
            stackId="stack"
          />
          <Legend
            content={(props) => customLegend(props)}
            position="top"
          />
          {!props.isExport && (<Tooltip
            content={(props) => customTooltip(props, "specialtyGroupDisplayName")}
            cursor={{ fill: props.barHoverBackground }}
            itemStyle={{ background: "white", color: "black" }}
          />)}
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
};

export default TopSpecialtiesTable;